import { IExportTemplate } from './index';

export class ISavedTemplate {
  exportDataTemplateName: string;
  exportDataTemplate: IExportTemplate;
  exportDataTemplateId: number;
}



